import { useEffect, useRef } from 'react';

export interface UseIntervalArgs {
  intervalInMilliseconds: number | null;
  intervalFunction: () => void;
}

export const useInterval = ({ intervalInMilliseconds, intervalFunction }: UseIntervalArgs) => {
  const savedIntervalFunction = useRef<UseIntervalArgs['intervalFunction'] | null>(null);

  // Remember the latest callback.
  useEffect(() => {
    savedIntervalFunction.current = intervalFunction;
  }, [intervalFunction]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedIntervalFunction.current?.();
    }

    if (intervalInMilliseconds !== null) {
      const id = setInterval(tick, intervalInMilliseconds);
      return () => clearInterval(id);
    }

    return () => {
      /* pass */
    };
  }, [intervalInMilliseconds]);
};
